<template>
  <div class="table-container">

    <table class="copyable-table">
      <thead>
        <tr>
          <th>标的名称</th>
          <th>标的代码</th>
          <th>类型</th>
          <th>期限月数</th>
          <th>锁定月数</th>
          <th>敲入</th>
          <th>敲出</th>
          <th>降敲出步长</th>
          <th>执行价</th>
          <th>保底</th>
          <th>红利票息</th>
          <th>保证金</th>
          <th>报价年化票息</th>
          <th>二级票息率(年化)</th>

        </tr>
      </thead>
     <tbody>
      <tr v-for="(row, index) in tableData" :key="index">
        <!-- 直接按索引渲染所有字段 -->
        <td>{{ row.stock_code }}</td> <!-- 标的名称 -->
        <td>{{ row.stock_name }}</td> <!-- 标的代码 -->
        <td>{{ row.structure }}</td> <!-- 类型 -->
        <td>{{ row.times }}</td> <!-- 期限月数 -->
        <td>{{ row.locked }}</td> <!-- 锁定月数 -->
        <td>{{ row.input }}</td> <!-- 敲入 -->
        <td>{{ row.out }}</td> <!-- 敲出 -->
        <td>{{ row.step }}</td> <!-- 降敲出步长 -->
        <td>{{ row.total_principal  }}</td><!-- 执行价 -->
        <td>{{ row.total_principal_label }}</td> <!-- 保底 -->
        <td>{{ row.brokerage }}</td> <!-- 红利票息 -->
        <td>{{ row.margin }}</td> <!-- 保证金 -->
        <td>{{ row.quoted }}</td> <!-- 报价年化票息 -->
        <td>{{ row.secondary }}</td> <!-- 早利雪球二级票息率 -->
      </tr>
    </tbody>
    </table>
      <button @click="copyTableToImage" class="button text-list-button">复制</button>
    </div>
</template>

<script>
import { copyTableToImage } from '@/utils/utils';

export default {
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    now_str: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      currentDate: (() => {
        const date = new Date();
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      })()
    };
  },

  methods: {
    roundPercent(value) {
      if (typeof value === 'string' && value.includes('%')) {
        const parsedValue = parseFloat(value.replace('%', '')) || 0;
        if (parsedValue < 1) {
          return (parsedValue * 100).toFixed(3) + '%';
        } else {
          return parsedValue.toFixed(2) + '%';
        }
      }
      const numericValue = parseFloat(value) || 0;
      return numericValue !== null && numericValue !== undefined ? (numericValue * 100).toFixed(2) + '%' : '0.0%';
    },
    isMinValue(row, key) {
      const values = Object.values(row).slice(6).map(v => {
        let parsedValue = 0;
        if (typeof v === 'string' && v.includes('%')) {
          parsedValue = parseFloat(v.replace('%', '')) || 0;
        } else {
          parsedValue = parseFloat(v) || 0;
        }
        if (parsedValue > 0 && parsedValue < 1) {
          parsedValue *= 100;
        }
        return parsedValue;
      }).filter(v => !isNaN(v) && v !== 0);

      if (values.length === 0) {
        return false;
      }

      const minValue = Math.min(...values);
      let value = 0;
      if (typeof row[key] === 'string' && row[key].includes('%')) {
        value = parseFloat(row[key].replace('%', '')) || 0;
      } else {
        value = parseFloat(row[key]) || 0;
      }
      if (value > 0 && value < 1) {
        value *= 100;
      }
      return value === minValue;
    },
    copyTableToImage() {
      const table = document.querySelector('.copyable-table');
      const firstRow = table.rows[1];
      const thirdCell = firstRow.cells[2];
      const cellContent = thirdCell.textContent;
      const fileName = '个股【'+cellContent+'】期权查询情况_' + this.currentDate + '.png';
      copyTableToImage(table, fileName);
    },



  },mounted() {
    // 初始化时调用一次
     console.log('Component mounted.');
    console.log(this.tableData);

  }
};
</script>

<style scoped>
@import '../assets/css/StockTable.css';

/* 美化 a 标签 */
.stock-link {
  color: #000; /* 链接颜色 */
  text-decoration: none; /* 去掉下划线 */
  transition: color 0.3s; /* 过渡效果 */
}

.stock-link:hover {
  color: #0056b3; /* 悬停时的颜色 */
  text-decoration: underline; /* 悬停时显示下划线 */
}
</style>
